import React from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";

import {getFullKMLink} from "../../../utils/get_full_km_link";

interface IProps {
    className?: string;
    onClick: () => void;
    buttonClassName?: string;
    onClickShowSentApplications: () => void;
    disableRedirectButton?: boolean;
    isModal?: boolean;
    isAuthenticated: boolean;
    successText?: string;
    onModalClose?: () => void;
}

export const ApplicationSuccessInfo = (props: IProps) => {
    const {successText, isAuthenticated, disableRedirectButton = false, onClickShowSentApplications, onClick, className} = props;

    return (
        <div className={cx(holderStyle, className)}>
            {props.onModalClose && (
                <button type="button" className={closeButtonStyle} onClick={props.onModalClose}>
                    <CloseIcon size="2.4" />
                </button>
            )}
            <Text variant="headline_3" className={headingStyle}>
                {successText ? successText : "Twoje zgłoszenie zostało wysłane do dewelopera"}
            </Text>
            {isAuthenticated && (
                <Text variant="body_copy_1" className={subheadingStyle}>
                    Możesz teraz odczytać je na{" "}
                    <Link size="big" href={getFullKMLink(kmAppLink.site.offers.appliedWithParams)} className={underlineStyle}>
                        swoim koncie
                    </Link>
                </Text>
            )}

            <div className={buttonsHolderStyle}>
                {!disableRedirectButton && isAuthenticated && (
                    <Button variant="filled_primary" onClick={onClickShowSentApplications} className={submitBtnStyle}>
                        Zobacz zgłoszenie
                    </Button>
                )}

                <Button variant="none_secondary" onClick={onClick}>
                    Powrót
                </Button>
            </div>
        </div>
    );
};

const holderStyle = css({
    py: 6,
    px: 2,
    position: "relative",
    md: {
        padding: 5
    }
});

const headingStyle = css({
    marginBottom: 4,
    color: "var(--colors-gray-800)",
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const subheadingStyle = css({
    color: "var(--colors-gray-800)",
    marginBottom: 8,
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const buttonsHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    md: {
        flexDirection: "row",
        justifyContent: "center"
    }
});

const submitBtnStyle = css({
    marginBottom: 2,
    md: {
        marginRight: 2,
        marginBottom: 0
    }
});

const underlineStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-800)"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});
import React from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";

import {getFullKMLink} from "../../../utils/get_full_km_link";

interface IProps {
    className?: string;
    onClick: () => void;
    buttonClassName?: string;
    onClickShowSentApplications: () => void;
    disableRedirectButton?: boolean;
    isModal?: boolean;
    isAuthenticated: boolean;
    successText?: string;
    onModalClose?: () => void;
}

export const ApplicationSuccessInfo = (props: IProps) => {
    const {successText, isAuthenticated, disableRedirectButton = false, onClickShowSentApplications, onClick, className} = props;

    return (
        <div className={cx(holderStyle, className)}>
            {props.onModalClose && (
                <button type="button" className={closeButtonStyle} onClick={props.onModalClose}>
                    <CloseIcon size="2.4" />
                </button>
            )}
            <Text variant="headline_3" className={headingStyle}>
                {successText ? successText : "Twoje zgłoszenie zostało wysłane do dewelopera"}
            </Text>
            {isAuthenticated && (
                <Text variant="body_copy_1" className={subheadingStyle}>
                    Możesz teraz odczytać je na{" "}
                    <Link size="big" href={getFullKMLink(kmAppLink.site.offers.appliedWithParams)} className={underlineStyle}>
                        swoim koncie
                    </Link>
                </Text>
            )}

            <div className={buttonsHolderStyle}>
                {!disableRedirectButton && isAuthenticated && (
                    <Button variant="filled_primary" onClick={onClickShowSentApplications} className={submitBtnStyle}>
                        Zobacz zgłoszenie
                    </Button>
                )}

                <Button variant="none_secondary" onClick={onClick}>
                    Powrót
                </Button>
            </div>
        </div>
    );
};

const holderStyle = css({
    py: 6,
    px: 2,
    position: "relative",
    md: {
        padding: 5
    }
});

const headingStyle = css({
    marginBottom: 4,
    color: "var(--colors-gray-800)",
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const subheadingStyle = css({
    color: "var(--colors-gray-800)",
    marginBottom: 8,
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const buttonsHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    md: {
        flexDirection: "row",
        justifyContent: "center"
    }
});

const submitBtnStyle = css({
    marginBottom: 2,
    md: {
        marginRight: 2,
        marginBottom: 0
    }
});

const underlineStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-800)"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});
